import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;

export function useImportGuides() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/import/guides").then((r) => { cache = r.data; setData(r.data); }).catch(() => setData({ guides: [], common: {} }));
  }, []);
  return data;
}

export const guideSteps = (g, common) => [
  ...g.steps.map((body, i) => ({ title: i === 0 ? `Get your recipes out of ${g.label}` : null, body })),
  ...((common || {})[g.method] || []),
];

export const TAB_FOR = { file: "file", url: "url", bookmarks: "bookmarks", screenshot: "screenshot" };
